export default __webpack_public_path__ + "static/media/grid.343b5afc.svg";